import React, {
    useState,
    useEffect,
 
} from "react"
import {  Typography } from './ot'

const BaseListView1_2 = ({
    value = "",
    titleLevel = 5,
    className = "!text-sm sm:!text-base !mb-0",
    style = {},
    
}, ref) => {
    

    return (
        <Typography.Title level={titleLevel} className={className} style={style}>
            {value}
        </Typography.Title>
    )
}

export default BaseListView1_2
